import Button from 'ui/components/buttons/Button/'
import Icon from 'ui/components/Icon'
import {
  DescriptionTemplatesHintStyled,
  Left,
  Text,
  Actions,
  ButtonSelectWrap,
  ButtonCloseWrap,
} from './styled'

const DescriptionTemplatesHint = ({
  text = 'Вы можете использовать шаблоны для описания',
  buttonTitle = 'Выбрать шаблон',
  onSelectTemplate,
  onClose,
}) => {
  return (
    <DescriptionTemplatesHintStyled>
      <Left>
        <Icon name="info" size={20} />
        <Text>{text}</Text>
      </Left>

      <Actions>
        <ButtonSelectWrap>
          <Button
            type="button"
            theme="borderBlue"
            title={buttonTitle}
            onClick={onSelectTemplate}
          />
        </ButtonSelectWrap>

        <ButtonCloseWrap>
          <Button
            type="button"
            theme="iconTemplatesHint"
            icon={<Icon name="close" size={10} />}
            onClick={onClose}
          />
        </ButtonCloseWrap>
      </Actions>
    </DescriptionTemplatesHintStyled>
  )
}

export default DescriptionTemplatesHint
